import { render, staticRenderFns } from "./Barcodes.vue?vue&type=template&id=40cb8155&"
import script from "./Barcodes.vue?vue&type=script&lang=js&"
export * from "./Barcodes.vue?vue&type=script&lang=js&"
import style0 from "./Barcodes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QTr,QTh,QBtn,QDialog,QCard,QCardSection,QInput,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QTr,QTh,QBtn,QDialog,QCard,QCardSection,QInput,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
